import React from 'react'
import styled from 'styled-components'
import Button from '../../../components/Button/Button'
import FileUpload from '../../../components/FileUpload/FileUpload'
import PropTypes from 'prop-types'
import { domains } from '../../../lib/config'

PakUploadLayout.propTypes = {
  error: PropTypes.string,
  file: PropTypes.object,
  fileName: PropTypes.string.isRequired,
  handleUpload: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onFileChange: PropTypes.func.isRequired,
  uploadResults: PropTypes.object,
}

export default function PakUploadLayout(props) {
  return (
    <React.Fragment>
      <h2>Upload PAK Codes</h2>
      <hr />
      <Instructions>
        Select an Excel spreadsheet (.xls or .xlsx) containing PAK codes upload
      </Instructions>
      <FileUpload
        disabled={props.isLoading}
        fileName={props.fileName}
        key={props.fileName}
        onFileChange={props.onFileChange}
      >
        Browse
      </FileUpload>
      <UploadSection>
        <div>
          {props.error && <Error>{props.error}</Error>}
          {!!props.uploadResults && (
            <Results error={props.error} uploadResults={props.uploadResults} />
          )}
        </div>
        <div>
          <Button
            color={'#002855'}
            disabled={!props.file || props.isLoading}
            onClick={props.handleUpload}
          >
            Upload
          </Button>
        </div>
      </UploadSection>
      <Instructions>
        All uploaded spreadsheets should be formatted like this:
      </Instructions>
      <ExampleImage
        src={`${domains.CDN_DOMAIN}/assets/img/spreadsheet_example.png`}
      />
    </React.Fragment>
  )
}

const ExampleImage = styled.img`
  width: 100%;
`

const Instructions = styled.span`
  font-family: Molde-bold;
  padding: 0.6rem 0;
`

const Error = styled.span`
  color: red;
`

const UploadSection = styled.div`
  display: flex;
  padding: 1rem 0 0.5rem;

  & > div {
    display: flex;
    flex: 1;
  }

  & > div + div {
    justify-content: flex-end;
    align-items: baseline;
  }
`

// Results Section
Results.propTypes = {
  uploadResults: PropTypes.object.isRequired,
}
function Results(props) {
  const { uploadResults } = props
  const hasErrors = uploadResults.errors && !!uploadResults.errors.length
  return (
    <ResultsWrapper hasErrors={hasErrors}>
      <React.Fragment>
        <span>{`${uploadResults.addedCount + uploadResults.duplicateCount}/${
          uploadResults.totalPaks
        } codes ${hasErrors ? '' : 'successfully'} processed:`}</span>
        <List>
          <li>{`${uploadResults.addedCount} codes inserted into the database`}</li>
          <li>{`${uploadResults.duplicateCount} codes were skipped because they were already in the database`}</li>
        </List>
        {hasErrors && (
          <Instructions>
            Please make changes to the following PAK codes and re-upload
          </Instructions>
        )}
        {uploadResults.errors.map(error => (
          <div key={error.rowNumber}>
            <span>CODE ROW {error.rowNumber}</span>
            <List hasErrors={hasErrors}>
              {error.errors.map((e, index) => (
                <li key={index}>{mapErrorToMessage(e, error.code)}</li>
              ))}
            </List>
          </div>
        ))}
      </React.Fragment>
    </ResultsWrapper>
  )
}

const ResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => (props.hasErrors ? 'black' : 'green')};
`

const List = styled.ul`
  color: ${props => (props.hasErrors ? 'red' : 'green')};
  padding-left: 1rem;
`
const mapErrorToMessage = (errCode, pakNo) => {
  switch (errCode) {
    case 'Empty':
      return 'Code is empty'
    case 'InvalidLength':
      return 'Code is not 12 characters long'
    case 'InvalidCharacter':
      return 'Code contains unrecognized characters. Use numbers and letters only.'
    case 'InvalidCode':
      // prettier-ignore
      return `Unrecognized product code "${pakNo.substring( 0, 3, )}"${pakNo.substring(3)}`
    case 'InvalidGrade':
      // prettier-ignore
      return `Unrecognized grade code ${pakNo.substring(0,3)}"${pakNo.substring(3, 4)}"${pakNo.substring(4)}`
    case 'DuplicatePakNumber':
      return `Code has already been added`
    default:
      return 'An error occured while PAK codes were being inserted into the database. Please upload the spreadsheet again'
  }
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/pakUpload/PakUploadLayout.js